import axios from 'axios';
import axiosRetry from "axios-retry";

const getDefaultState = () => {
    return {
        isUploadVisible: false,
        blobCache: {},
    }
}

// initial state
const state = getDefaultState()

const getters = {
    getIsUploadVisible: state => state.isUploadVisible,
}

const actions = {

    // checkPicture({ commit, dispatch, state, rootState }, payload) {
    //
    //     const payload_checkPicture = {
    //         name: payload.name,
    //         ext: payload.ext,
    //         type: payload.type
    //     }
    //
    //     const baseAPI = rootState.tenant.tenantinfo.baseAPI;
    //
    //     const imageName =`${payload.name}.${payload.ext}`;
    //
    //     // Works with custom axios instances
    //     const client = axios.create({
    //         baseURL: baseAPI
    //     })
    //     axiosRetry(client, {
    //         retries: 3,
    //         retryDelay: axiosRetry.exponentialDelay
    //     })
    //
    //     let config = {
    //         headers: {
    //             Authorization: rootState.auth.bearer
    //         }
    //     }
    //
    //     try {
    //
    //         const picture_payload = {
    //             picture: imageName
    //         }
    //
    //
    //         let response = client
    //             .post('file/get-upload-signed-url', payload_checkPicture, config)
    //             .then(result => {
    //                 // console.log('retry OK')
    //                 // console.log(result.data)
    //                 result.data // 'ok'
    //
    //                 if (payload.folder_name === 'profile') {
    //                     dispatch('auth/setUserPicture', picture_payload, { root: true })
    //                 }
    //
    //             })
    //             .catch(error => {
    //                 // The first request fails
    //                 console.log('retry error')
    //                 console.log(error)
    //             })
    //     } catch (err) {
    //         alert(err)
    //         console.log(err)
    //         commit('loading/setLoading', false, {
    //             root: true
    //         })
    //         commit('setUploadVisible', false)
    //     }
    // },

    async uploadFile({ commit, dispatch, state, rootState }, payload) {

        const baseAPI = rootState.tenant.tenantinfo.baseAPI;

        axios.defaults.baseURL = baseAPI;

        let config = {
            headers: {
                Authorization: rootState.auth.bearer
            }
        }
        try {
            const payload_signedURL = {
                name: payload.name,
                ext: payload.ext,
                type: payload.type,
                folder_name: payload.folder_name
            }

            let response = await axios.post(
                'v2/file/get-upload-signed-url',
                payload_signedURL,
                config
            )

            const payload_file = payload.file;

            await axios.put(response.data.uploadURL, payload_file, {
                headers: {
                    'Content-Type': payload.type,
                },
                timeout: 30000,
            });
            // await dispatch('checkPicture', payload_signedURL);

            if (payload.folder_name === 'profile') {

                const imageName =`${payload.name}.${payload.ext}`;

                const picture_payload = {
                    picture: imageName
                }

                await dispatch('auth/setUserPicture', picture_payload, { root: true })
            }

        } catch (err) {
            commit('loading/setLoading', false, { root: true })
            commit('setUploadVisible', false)
            throw err;
        }
    },

    async getFile({commit, dispatch, rootState}, payload) {

        // Digistore24 B2C buyer: route to the public ds24 download endpoint with
        // the B2C session token instead of the Cognito bearer.
        const isB2C = payload && payload.b2c;

        try {

            if (isB2C && rootState.tenant.tenantinfo && rootState.tenant.tenantinfo.baseAPI) {
                axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
            }

            let config = {
                headers: {
                    Authorization: isB2C
                        ? `Bearer ${rootState.ds24.sessionToken}`
                        : rootState.auth.bearer
                },

            };

            let payloadAPI = {};

            if (payload.hasOwnProperty('full_key')) {
                payloadAPI = {
                    full_key: payload.full_key
                }
            }
            else {
                payloadAPI = {
                    file_name: payload.file_name,
                    folder_name: payload.folder_name
                };
            }

            if (payload.hasOwnProperty('file_label')) {
                payloadAPI.file_label = payload.file_label;
            }

            const url = isB2C
                ? '/v2/ds24/file/get-download-signed-url'
                : '/v2/file/get-download-signed-url';

            const response = await axios.post(url, payloadAPI, config);

            return response.data.downloadURL;

        }
        catch (err) {
            // throw new Error(err);
        }

    },

    async getFileURL({ state, commit, rootState }, payload) {
        try {
            const key = `${payload.folderName}/${payload.fileName}`;

            // return cached blob if exists
            if (state.blobCache[key]) {
                return state.blobCache[key];
            }

            const baseAPI = rootState.tenant.tenantinfo.baseAPI;
            const url = `${baseAPI}/v2/file/medium/original/${payload.fileName}/${payload.folderName}`;

            const response = await fetch(url, {
                headers: {
                    Authorization: rootState.auth.bearer
                }
            });

            if (!response.ok) {
                throw new Error('Image loading failed');
            }

            // const blob = await response.blob();
            // const blobURL = URL.createObjectURL(blob);
            //
            // return blobURL;

            const contentType = response.headers.get('Content-Type') || '';

            // -------------------------
            // JSON
            // -------------------------
            if (contentType.includes('application/json')) {
                return await response.json();
            }

            // -------------------------
            // TEXT (optional)
            // -------------------------
            if (contentType.startsWith('text/')) {
                return await response.text();
            }

            // -------------------------
            // EVERYTHING ELSE (images, pdf, docx, etc.)
            // -------------------------
            const blob = await response.blob();
            const blobURL = URL.createObjectURL(blob);

            commit('SET_BLOB_CACHE', {
                key,
                url: blobURL
            });

            return blobURL;
        } catch (err) {
            console.error(err);
        }

    },

    async loadAllImages({ dispatch }, journeys) {
    const imageLoadPromises = journeys.map(async (journey) => {
      if (journey.Picture) {
        journey.PictureURL = await dispatch('getFile', {
          file_name: journey.Picture,
          folder_name: `journey/${journey.ID}`
        });
      }
    });

    await Promise.all(imageLoadPromises);
  },


    async getTenantLogoFile({commit, dispatch, rootState}) {

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },

            };

            let payloadAPI = {
                file_name: rootState.tenant.tenantinfo.logo,
                tenant_id: rootState.tenant.tenantinfo.id
            };

            const response = await axios.post('/v2/file/get-tenant-logo-signed-url', payloadAPI, config);

            return response.data.downloadURL;

        }
        catch (err) {
            // throw new Error(err);
        }

    },

    async getTenantPwaLogoFile({commit, dispatch, rootState}) {
        try {
            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },
            };

            let payloadAPI = {
                file_name: rootState.tenant.tenantinfo.pwa_logo,
                tenant_id: rootState.tenant.tenantinfo.id
            };

            const response = await axios.post('/v2/file/get-tenant-logo-signed-url', payloadAPI, config);
            return response.data.downloadURL;
        } catch (err) {
            // throw new Error(err);
        }
    },

    async getSVG({commit, dispatch, rootState}, data) {

        try {

            let config = {
                headers: {
                    Authorization: rootState.auth.bearer
                },

            };

            let payload = {
                file_name: data.file_name,
                folder_name: data.folder_name
            };

            const response = await axios.post('/v2/file/get-download-signed-url', payload, config);

            let signedURL = response.data.downloadURL;

            const svgResponse = await axios.get(signedURL, { responseType: 'text' })

            return svgResponse.data;

        }
        catch (err) {
            // throw new Error(err);
        }

    },

    async deleteFile({ commit, state, rootState }, payload) {
        commit('loading/setLoading', true, { root: true });
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        let config = {
            headers: {
                Authorization: rootState.auth.bearer
            },
            data: {
                folder_name: payload.folder_name,
                file_name: payload.file_name
            },
        }
        try {
            await axios.delete('/v2/file/delete-file', config)

            commit('loading/setLoading', false, { root: true })
        } catch (err) {
            commit('loading/setLoading', false, { root: true })
        }
    },

    async deleteResizedVersionsOfFile({ commit, state, rootState }, payload) {
        commit('loading/setLoading', true, { root: true });
        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        let config = {
            headers: {
                Authorization: rootState.auth.bearer
            },
            data: {
                folder_name: payload.folder_name,
                file_id: payload.file_id
            },
        }
        try {

            await axios.delete('/v2/file/delete-resized-versions-of-file', config);

            commit('loading/setLoading', false, { root: true })
        } catch (err) {
            commit('loading/setLoading', false, { root: true })
        }
    },

    async copyFileBetweenS3Folders({commit, dispatch, rootState}, payload) {

        commit('loading/setLoading', true, { root: true });

        axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

        let config = {
            headers: {
                Authorization: rootState.auth.bearer
            },
        };

        let payloadAPI = {
            source_key: payload.source_key,
            folder_name: payload.folder_name,
            file_name: payload.file_name,
        };
        try {
            await axios.post('/v2/file/copy-file-to-S3-folder', payloadAPI, config)
            commit('loading/setLoading', false, { root: true });

        } catch (err) {

            commit('loading/setLoading', false, { root: true })
        }

    }

}

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },

    setUploadVisible(state, status) {
        state.isUploadVisible = status
    },
    SET_BLOB_CACHE(state, { key, url }) {
        state.blobCache[key] = url;
    },

    CLEAR_BLOB_CACHE(state) {
        Object.values(state.blobCache).forEach(url => {
            if (url?.startsWith('blob:')) {
                URL.revokeObjectURL(url);
            }
        });

        state.blobCache = {};
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState());
      },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
